import { useMutation } from "@tanstack/react-query";
import type { IContactRequest, IContactResponse } from "../types/contact.types";
import { sendContactRequest } from "./contactForm.api";
import { extractErrorMessage } from "@/lib/errors";
import { toast } from "sonner";

export const useSendContactRequest = () => {
  return useMutation<IContactResponse, Error, IContactRequest>({
    mutationFn: sendContactRequest,
    onSuccess: () => {
      toast.success("Message sent successfully");
    },
    onError: (error) => {
      toast.error("Failed to send message", {
        description: extractErrorMessage(error),
      });
    },
  });
};
